import { Box, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FiltersTabContent = styled(Box)(() => ({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',

  '.MuiButton-text': {
    margin: '0 0 10px auto',
  },
}));

export const FilterCollapses = styled(Box)(() => ({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  paddingRight: '5px',
  overflow: 'auto',
}));

export const Loader = styled(CircularProgress)(() => ({
  margin: 'auto',
}));
